import cn from 'classnames';
import * as React from 'react';

import defaultImage from 'shared/img/listImage.png';
import { TranslationNode } from 'shared/entities/localization';
import TransComp from 'shared/components/TransComp';

import './StubComponent.modules.scss';

export enum StubSize {
  l = 'l',
  m = 'm',
  s = 's'
}

export type StubProps = {
  image?: string;
  text?: TranslationNode;
  extraNode?: React.ReactNode;
  size?: StubSize;
  className?: string;
};

const StubComponent: React.FC<StubProps> = ({
  image,
  text = (t) => t('stubComponent.content', { ns: 'components' }),
  extraNode,
  size = StubSize.m,
  className
}) => {
  return (
    <div styleName={cn('stub-container', `stub-container_${size}`)}>
      <div className={className}>
        <div
          styleName="stub"
          style={{
            backgroundImage: `url(${image || defaultImage})`
          }}
        />
        <div styleName="stub__content">
          <TransComp>{text}</TransComp>
          {extraNode && <div className="form-item_xs">{extraNode}</div>}
        </div>
      </div>
    </div>
  );
};

export default React.memo(StubComponent);
